exports.onServiceWorkerUpdateReady = () => {//TODO
    const answer = window.confirm(
        `This application has been updated. ` +
        `Reload to display the latest version?`
    )
    if (answer === true) {
        localStorage.clear(); //TODO - should be more exact :)
        window.location.reload()
    }
}
/*
exports.onClientEntry = () => {
  // IntersectionObserver polyfill for gatsby-image (Safari, IE)
  if (typeof window.IntersectionObserver === `undefined`) {
    import(`intersection-observer`)
    console.log(`👍 IntersectionObserver is polyfilled`)
  }
}*/

exports.onServiceWorkerActive = () => {
    //TODO -  preload "webflow" assets - not cached on first load and obviously not handled by plugin, do in PWA directly
};

const ROUTE_ANNOUNCER_ID = 'linon-route-announcer'

function ensureRouteAnnouncer() {
    let el = document.getElementById(ROUTE_ANNOUNCER_ID)
    if (el) return el
    el = document.createElement('div')
    el.id = ROUTE_ANNOUNCER_ID
    el.setAttribute('aria-live', 'polite')
    el.setAttribute('aria-atomic', 'true')
    // Visually hidden, but kept in the a11y tree (unlike #gatsby-announcer
    // which we hide via display:none in css/app.css).
    Object.assign(el.style, {
        position: 'absolute',
        width: '1px',
        height: '1px',
        padding: '0',
        margin: '-1px',
        overflow: 'hidden',
        clip: 'rect(0, 0, 0, 0)',
        whiteSpace: 'nowrap',
        border: '0',
    })
    document.body.appendChild(el)
    return el
}

exports.onInitialClientRender = () => {
    ensureRouteAnnouncer()

    // dirty fix for missing popstate listener
    if (process.env.NODE_ENV !== `production`) {
        const GATSBY_NAVIGATE = window.___navigate || {}

        window.addEventListener('popstate', () =>
            GATSBY_NAVIGATE(window.location.pathname, { replace: true })
        )
    }
}

function triggerTracking(location, prevLocation) {
    if (window.tracking && window.tracking.trigger) {
        window.tracking.trigger(location, prevLocation)
    } else {
        console.warn("No tracking trigger found")
    }
}

function timeOutUntilTrackingIsDefined(callback, timeout = 16, totalTimeOut = 128) {
    if (window.tracking && window.tracking.trigger) {
        callback()
    } else {
        setTimeout(() => timeOutUntilTrackingIsDefined(callback, timeout), timeout)
    }
}

const { ariaLabel } = require('./src/components/Strings')

function announceRoute(location, prevLocation) {
    // Skip the first render: the browser already announced the initial title.
    if (!prevLocation) return
    if (prevLocation.pathname === location.pathname) return

    // Wait for Helmet to flush the new <title> and <html lang>. Helmet uses
    // requestAnimationFrame internally; a single rAF can land before it has
    // run, so we double-rAF to be safe — same trick Gatsby's own announcer
    // uses, but deferred one frame further to outlast Helmet's own rAF.
    requestAnimationFrame(() => requestAnimationFrame(() => {
        const announcer = ensureRouteAnnouncer()
        const locale = document.documentElement.lang || 'en'
        const title = document.title || location.pathname
        announcer.textContent = `${ariaLabel('Navigated to', locale)} ${title}`
    }))
}

exports.onRouteUpdate = ({ location, prevLocation }) => {
    timeOutUntilTrackingIsDefined(() => triggerTracking(location, prevLocation))
    announceRoute(location, prevLocation)
}

exports.shouldUpdateScroll = () => {
    // do not let gatsby do anything more
    // see RestoreScrollPosition.js
    return false
}
